import { Suspense } from 'react';

import { Route, Routes } from 'react-router-dom';

import { APIConfigRoutes } from '~/src/views/APIConfiguration/APIConfigurationRoutes';
import { AccountRoutes } from '~/src/views/Account/AccountRoutes';
import { ActivityRoutes } from '~/src/views/Activity/ActivityRoutes';
import { FulfillmentNetworkRoutes } from '~/src/views/FulfillmentNetwork/FulfillmentNetworkRoutes';
import { IntelligenceRoutes } from '~/src/views/Intelligence/IntelligenceRoutes';
import { MicroFrontendRoutes } from '~/src/views/MicroFrontend/MicroFrontendRoutes';
import { ReconciliationRoutes } from '~/src/views/Reconciliation/ReconciliationRoutes';
import { SimulateRoutes } from '~/src/views/Simulate/SimulateRoutes';
import SalesSimulationResultsPage from '~/src/views/Simulate/pages/Simulate/SalesSimulateResultsPage';
import { salesSimulationFullPage } from '~/src/views/Simulate/pages/Simulate/constants/links';

import { AuthGuard } from './AuthGuard';
import { DefaultScreenSkeleton } from './DefaultScreenSkeleton';
import { ResendVerification } from './EmailVerify/ResendVerification';
import { ResendVerificationSuccess } from './EmailVerify/ResendVerificationSuccess';
import { FullWidthLayoutSkeleton } from './FullWidthLayoutSkeleton';
import { Index } from './Index';
import { Layout } from './Layout/Layout';
import { StopImpersonateButton } from './StopImpersonateButton';

export const ProtectedRoutes = () => (
  <Suspense
    fallback={
      location.pathname.includes(salesSimulationFullPage) ? (
        <FullWidthLayoutSkeleton />
      ) : (
        <Layout>
          <DefaultScreenSkeleton />
        </Layout>
      )
    }
  >
    <AuthGuard>
      <>
        <StopImpersonateButton />
        <Layout>
          <Routes>
            <Route element={<ActivityRoutes />} path="/activity/*" />
            <Route element={<FulfillmentNetworkRoutes />} path="/settings/*" />
            <Route element={<APIConfigRoutes />} path="/api-config/*" />
            <Route element={<IntelligenceRoutes />} path="/intelligence/*" />
            <Route element={<SalesSimulationResultsPage />} path={salesSimulationFullPage} />
            <Route element={<SimulateRoutes />} path="/simulate/*" />
            <Route element={<ReconciliationRoutes />} path="/reconciliation/*" />
            <Route element={<AccountRoutes />} path="/account/*" />
            <Route element={<MicroFrontendRoutes />} path="/micro-frontend/*" />
            <Route element={<ResendVerification />} path="/resend_verification/*" />
            <Route element={<ResendVerificationSuccess />} path="/resend_verification/success/*" />
            <Route element={<Index />} path="*" />
          </Routes>
        </Layout>
      </>
    </AuthGuard>
  </Suspense>
);
